import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import { EDITABLE_TITLE_RELOAD } from '@/lib/analytics/page-meta';
import { loadAdminLearningTrackMeta } from '@/lib/queries/learning-tracks';
import { requirePlatformRole } from '@/lib/route-guards';
import {
  LearningTrackAdminSkeleton,
  LearningTrackAdminView,
} from '@/components/learning-tracks/LearningTrackAdminView';

export const Route = createFileRoute(
  '/_authed/admin/resources/learning-tracks/$trackId/',
)({
  beforeLoad: ({ params, context }) => {
    if (!isUuid(params.trackId)) throw notFound();
    requirePlatformRole(context, {
      role: 'admin',
      bounceTo: () =>
        redirect({
          to: '/resources/learning-tracks/$trackId',
          params: { trackId: params.trackId },
        }),
    });
  },
  loader: {
    handler: ({ params, context: { queryClient } }) =>
      loadAdminLearningTrackMeta(queryClient, params.trackId),
    staleReloadMode: EDITABLE_TITLE_RELOAD,
  },
  // Hover preload would run this loader, and with it the admin detail fetch,
  // for every row the pointer crosses in the admin list. The route chunk still
  // preloads; the data waits for the click.
  preload: false,
  pendingComponent: LearningTrackAdminSkeleton,
  component: LearningTrackAdminPage,
});

function LearningTrackAdminPage() {
  const { trackId } = Route.useParams();
  return <LearningTrackAdminView trackId={trackId} />;
}
